import(/* webpackMode: "eager" */ "/home/ubuntu/vizion-analytics/web/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/vizion-analytics/web/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/home/ubuntu/vizion-analytics/web/src/app/providers.tsx");
